<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none"><circle cx="12" cy="12" r="8" fill="currentColor" /></svg>
</template>
